import React, { createContext, useEffect, useState } from 'react';

export const CallersIdContext = createContext();

export const CallersIdProvider = ({ children }) => {
    const [callers, setCallers] = useState([]); 

    useEffect(() => {
        console.log('Current Callers:', callers);
    }, [callers]);

    return (
        <CallersIdContext.Provider value={{ callers, setCallers }}>
            {children}
        </CallersIdContext.Provider>
    );
};
